/**
 * Palantir PMS - Software para la gestión de la industria hotelera
 * Palantir PMS - Software for hotel industry management
 * Autor / Author: Alberto Castro Ull
 * Fecha de creación / Created on: 31/07/2025
 * Todos los derechos reservados / All rights reserved.
 * Este software es propiedad de Alberto Castro Ull.
 * This software is the property of Alberto Castro Ull.
 * Su uso está restringido a clientes con licencia emitida por Markulia Group, S.L.
 * Use is restricted to clients licensed by Markulia Group, S.L.
 */

// utils/guestHelpers.js

export const getGuestContext = ({
  showNewCustomerForm,
  editingChildIndex,
  editingAccompanyingIndex,
} = {}) => {

  console.log(
    "[getGuestContext] showNewCustomerForm:", showNewCustomerForm,
    "| editingAccompanyingIndex:", editingAccompanyingIndex,
    "| editingChildIndex:", editingChildIndex
  );

  if (typeof showNewCustomerForm === "string") {
    if (showNewCustomerForm.startsWith("accompanying-")) return "accompanying";
    if (showNewCustomerForm.startsWith("child-")) return "child";
    if (showNewCustomerForm === "booker") return "booker";
  }

  if (typeof showNewCustomerForm === "boolean" && showNewCustomerForm === true) {
    return "main_guest";
  }

  if (editingChildIndex !== null) return "child";
  if (editingAccompanyingIndex !== null) return "accompanying";

  return null;
};

export const isEditingAnyRole = (showNewCustomerForm) => {
  return (
    showNewCustomerForm === true || // main guest
    showNewCustomerForm === "booker" ||
    (typeof showNewCustomerForm === "string" &&
      (showNewCustomerForm.startsWith("accompanying-") ||
       showNewCustomerForm.startsWith("child-")))
  );
};

